import { formatMoney as format } from "@shopify/theme-currency";
import c from "shopify-currency";

const currency = c(typeof currencyOpts !== "undefined" ? currencyOpts : {});

export const formatMoney = val =>
  format(val, theme.moneyFormat || "${{amount}}");

export default currency;
